// extracted by mini-css-extract-plugin
module.exports = {"pagination":"styles_pagination__hnGuw"};